module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-fr.7d5c7541.svg";